import { carrierRateTablesSchema } from "@redotech/redo-fulfillment-rate-table-common/global-rate-tables";
import * as z from "zod";

export const getBaselineRateTables = {
  name: "getBaselineRateTables" as const,
  input: z.object({}),
  output: z.object({ rateTables: carrierRateTablesSchema.nullable() }),
};
